<template>
    <div style="padding: 10px;">
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">Preferencias Básicas</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <h3 class="card-title">Mapa</h3>
                        <br>
                        <h5 class="card-title">Horas a mostrar en recorridos</h5>
                        <el-slider v-if="this.slideOk" class="slider-success"
                                v-model="slideBack"
                                :show-tooltip="false"
                                show-stops
                                :step="1"
                                :marks="marks"
                                :min="0"
                                :max="12"
                                @change="saveSlider"
                                :format-tooltip="formatTooltip">
                        </el-slider>
                    </div>
                    <div class="col-md-6">
                        <h3 class="card-title">Apariencia</h3>
                        <br>
                        <div class="row">
                            <h5 style="margin-left: 20px">Contraer Sidebar</h5>
                            <p-switch v-model="sidebarMini"
                                type="primary" on-text="ON" off-text="OFF"
                                @input="saveSidebarMini"
                                style="margin-left: 20px; ">
                            </p-switch>
                        </div>
                    </div>
                </div>
                <br>
                <!-- <p-button @click="saveSettings()" style="float: right">Guardar</p-button> -->
            </div>
        </div>
    </div>
</template>

<script>
import {Slider} from 'element-ui'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import {Button} from 'src/components/UIComponents'
import {mapState} from 'vuex'
import {SettingsService} from '../../../services/storage.service'

export default {
    components: {
      [Slider.name]: Slider,
      PSwitch,
      [Button.name]: Button
    },
    mounted() {
        this.handleResize()
        window.addEventListener("resize", this.handleResize)
        this.getObjectIndex()
        this.sidebarMini = SettingsService.getSidebarSettings()
    },
    data() {
        return {
            slideBack: 0,
            slideOk: false,
            marks: {
                0: {label:'0:00', value:0},
                1: {label:'0:30', value:30},
                2: {label:'1:00', value:60},
                3: {label:'1:30', value:1.5*60},
                4: {label:'2:00', value:2*60},
                5: {label:'2:30', value:2.5*60},
                6: {label:'3:00', value:3*60},
                7: {label:'4:00', value:4*60},
                8: {label:'5:00', value:5*60},
                9: {label:'6:00', value:6*60},
                10: {label:'9:00', value:9*60},
                11: {label:'12:00', value:12*60},
                12: {label:'24:00', value:24*60},
            },
            sidebarMini: true
        }
    },
    computed: {
        ...mapState(["settings","positionQuery"])
    },
    methods: {
        getObjectIndex() {
            for (var key in this.marks) {
                var keyVal = this.marks[key];
                if (keyVal.value == this.positionQuery.minutesBackward){
                    this.slideBack=parseInt(key)
                }
            }
            this.slideOk = Boolean
        },
        saveSlider(){
            this.$store.commit("setMinutesBackward",this.marks[this.slideBack].value)
            SettingsService.saveMinutesSettings(this.marks[this.slideBack].value)            
        },
        formatTooltip(val) {
            //return this.marks[val].label;
        },
        saveSidebarMini() {
            this.$store.commit('setSettings', {
                sidebarMini: this.sidebarMini
            })
            SettingsService.saveSidebarSettings(this.sidebarMini)
        },
        handleResize() {
            let navbarHeight = document.getElementById("navbar").offsetHeight;
            let windowHeight = window.innerHeight;
            let contentHeight = windowHeight - navbarHeight;
            document.getElementById("content").style.height = contentHeight + "px";
            document.getElementById("sidebar").style.height = windowHeight + "px";
        }
    }
}
</script>

<style scoped>
.slider-success {
    padding: 20px;
}
.card .card-content, .card-body{
    padding: 0px 15px 0px 15px;
    box-shadow: 0 6px 10px -4px rgba(40, 40, 40, 0.7);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
}
</style>
